/* global rp$, window */

import './add_vin_fitment.scss';
const { handleGarageData } = require('public/js/components/garage-store');

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Add VIN Fitment module: button or confirmed banner + inline form.
	 * Toggle form on button click, or "Change VIN" shows form and "Cancel" shows banner.
	 ********************************************/
	(function AddVINFitmentModule() {
		'use strict';

		$onReady({
			rp$, window,
			label: 'add_vin_fitment',
			fn: function () {
				rp$('.add-vin-fitment-module').each(function () {
					const $module = rp$(this);
					const $btn = $module.find('.btn-form-vin-modal');
					const $confirmed = $module.find('.add-vin-fitment-confirmed');
					const $form = $module.find('.add-vin-fitment-inline-form');
					const $input = $module.find('.vin-input-field');
					const $submitBtn = $module.find('.vin-submit-button');
					const $errorContainer = $module.find('.vin-error-container');
					const $successContainer = $module.find('.vin-success-container');
					const $changeVinLink = $module.find('.add-vin-fitment-change-vin-link');
					const $cancelLink = $module.find('.add-vin-fitment-cancel-link');

					if ($form.length === 0) {
						return;
					}

					const $popoverLink = $module.find('.popover-tooltip-vin');
					const findVinUrl = 'https://cdn-static.revolutionparts.io/assets/images/find_vin.gif';

					function showForm() {
						$module.addClass('add-vin-fitment-form-visible');
						$form.removeAttr('hidden');
						if ($btn.length > 0) {
							$btn.attr('aria-expanded', 'true').removeClass('add-vin-fitment-btn-hidden');
						}
						if ($confirmed.length > 0) {
							$confirmed.hide();
						}
						$input.focus();
						if ($popoverLink.length > 0 && typeof $popoverLink.popover === 'function') {
							$popoverLink.popover({
								trigger: 'focus',
								placement: 'bottom',
								content: '<img class="wheres-my-vin" src="' + findVinUrl + '" alt=""/>',
								html: true,
								container: 'body'
							});
						}
					}

					function hideForm() {
						$module.removeClass('add-vin-fitment-form-visible');
						$form.attr('hidden', 'hidden');
						if ($btn.length > 0) {
							$btn.attr('aria-expanded', 'false');
							if ($confirmed.length > 0) {
								$btn.addClass('add-vin-fitment-btn-hidden');
							}
						}
						if ($confirmed.length > 0) {
							$confirmed.show();
						}
						$input.val('');
						$errorContainer.hide().empty();
						$successContainer.hide();
						if ($popoverLink.length > 0 && typeof $popoverLink.popover === 'function') {
							try {
								$popoverLink.popover('dispose');
							} catch (err) {}
						}
					}

					if ($btn.length > 0) {
						$btn.on('click', function (e) {
							e.preventDefault();
							if ($form.attr('hidden') !== undefined) {
								showForm();
							} else {
								hideForm();
							}
						});
					}

					$changeVinLink.on('click', function (e) {
						e.preventDefault();
						showForm();
					});

					$cancelLink.on('click', function (e) {
						e.preventDefault();
						hideForm();
					});

					$submitBtn.on('click', function (e) {
						e.preventDefault();
						handleGarageData.clearGarageCache();
						const vinModal = require('public/js/components/vin-modal.js');
						vinModal.submitVinInline($input, $submitBtn, $errorContainer, $successContainer, function () {
							globalThis.location.reload();
						});
					});

					$input.on('keypress', function (e) {
						if (e.which === 13 || e.keyCode === 13) {
							e.preventDefault();
							$submitBtn.trigger('click');
						}
					});
				});
			},
		});

	})();
};

try {
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
